import { render, staticRenderFns } from "./AllJoin.vue?vue&type=template&id=1a12c267";
import script from "./AllJoin.vue?vue&type=script&lang=js";
export * from "./AllJoin.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;